export const Boxes1 = ({
  height = "16",
  width = "16",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_108_5537)">
      <path
        d="M11.1668 10H13.8335V11.3333H11.1668V10ZM16.8335 9.33333V16H0.833496V9.33333C0.833496 8.23067 1.73083 7.33333 2.8335 7.33333H4.16683V2C4.16683 0.897333 5.06416 0 6.16683 0H11.5002C12.6028 0 13.5002 0.897333 13.5002 2V7.33333H14.8335C15.9362 7.33333 16.8335 8.23067 16.8335 9.33333ZM5.50016 7.33333H12.1668V2C12.1668 1.632 11.8682 1.33333 11.5002 1.33333H6.16683C5.79883 1.33333 5.50016 1.632 5.50016 2V7.33333ZM2.16683 14.6667H8.16683V8.66667H2.8335C2.4655 8.66667 2.16683 8.96533 2.16683 9.33333V14.6667ZM15.5002 9.33333C15.5002 8.96533 15.2015 8.66667 14.8335 8.66667H9.50016V14.6667H15.5002V9.33333ZM3.8335 10V11.3333H6.50016V10H3.8335ZM7.50016 4H10.1668V2.66667H7.50016V4Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_108_5537">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.833496)"
        />
      </clipPath>
    </defs>
  </svg>
);
